








































import { Component, Ref } from "vue-property-decorator"
import FaoCountryModule from "@/store/modules/fao/FaoCountryModule"
import VueTrans from "@/mixins/VueTrans.vue"
import AutoComplete from "@/components/inputs/AutoComplete.vue"
import { FaoCountry } from "@/model/interfaces/fao/faoCountry"
import { ValidationObserver, ValidationProvider } from "vee-validate"
import SwitchCustom from "@/components/inputs/SwitchCustom.vue"

@Component({
  components: { SwitchCustom, AutoComplete, ValidationObserver, ValidationProvider }
})
export default class FaoCountryIso3Form extends VueTrans {
  @Ref("form") readonly form!: InstanceType<typeof ValidationObserver>
  transKey = "dashboard.dataAnalysis.globalHarmonisationSettings.form.faoCountry."

  get faoCountry(): FaoCountry {
    return FaoCountryModule.faoCountry
  }

  get dialog(): boolean {
    return FaoCountryModule.dialogForm
  }

  get loading(): boolean {
    return FaoCountryModule.loading
  }

  toUpperCase(faoCountry: FaoCountry): void {
    if (faoCountry.iso3) {
      faoCountry.iso3 = faoCountry.iso3.toUpperCase()
    }
  }

  async submit(): Promise<void> {
    try {
      if (this.faoCountry && FaoCountryModule.faoCountry) {
        if (FaoCountryModule.faoCountry) {
          await FaoCountryModule.saveCurrent()
        }
      }
    } finally {
      this.close()
    }
  }

  close(): void {
    this.form.reset()
    FaoCountryModule.setDialogForm(false)
  }
}
